import { render, staticRenderFns } from "./RemoteRouter.vue?vue&type=template&id=5cc1e4ba&scoped=true"
import script from "./RemoteRouter.vue?vue&type=script&lang=js"
export * from "./RemoteRouter.vue?vue&type=script&lang=js"
import style0 from "./RemoteRouter.vue?vue&type=style&index=0&id=5cc1e4ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1e4ba",
  null
  
)

export default component.exports